import useAppSelector from './useAppSelector';

export default function usePlans() {
  return useAppSelector(state => state.plans);
}
